import { http } from "./httpServices";
import {
  REGISTER,
  USERS,
  VERIFY_OTP,
  RESEND_OTP,
  SET_PIN,
  LOGIN,
  FORGOT_PIN,
  RESET_PIN,
  CHANGE_PIN,
  PROFILE,
  BALANCE,
  AAD_LOGIN,
  PASSPORT,
  PUSH,
  PUSH_NOTIFICATION,
  SET_VIDEO,
  API_VERSION,
} from "./constants";

export function register(data) {
  return http.post(API_VERSION + USERS + REGISTER, data);
}

export function verifyOtp(data) {
  return http.post(API_VERSION + USERS + VERIFY_OTP, data);
}

export function resendOtp(data) {
  return http.post(API_VERSION + USERS + RESEND_OTP, data);
}

export function setPin(data) {
  return http.post(API_VERSION + USERS + SET_PIN, data);
}

export function login(data) {
  return http.post(API_VERSION + USERS + LOGIN, data);
}

export function forgotPin(data) {
  return http.post(API_VERSION + USERS + FORGOT_PIN, data);
}

export function resetPin(data) {
  return http.post(API_VERSION + USERS + RESET_PIN, data);
}

export function changePin(data) {
  return http.post(API_VERSION + USERS + CHANGE_PIN, data);
}

export function fetchUserData() {
  return http.get(API_VERSION + USERS + PROFILE);
}

export function getEntitlementBalance() {
  return http.get(API_VERSION + USERS + BALANCE);
}

export function aadLogin(email, aadId) {
  return http.post(API_VERSION + USERS + AAD_LOGIN, { email, aadId });
}

export const getUsersPassport = () => {
  return http.get(API_VERSION + USERS + PASSPORT);
};

export const tokenRegister = (body) => {
  return http.put(API_VERSION + PUSH, body);
};

export const fetchNotificationList = () => {
  return http.get(API_VERSION + PUSH_NOTIFICATION);
};

export const deleteTokenRegister = (body) => {
  return http.post(API_VERSION + PUSH, body);
};


export const postVideoFlag = ()=>{
  return http.patch(API_VERSION + SET_VIDEO);

}